import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { formatDateTime } from "@/lib/cms";
import type { ActivityLog } from "@/lib/types";
import { PageHeader, Card, Spinner, EmptyState } from "@/pages/admin/components/ui";

export default function Historial() {
  const [logs, setLogs] = useState<ActivityLog[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const { data } = await supabase.from("activity_logs").select("*").order("created_at", { ascending: false }).limit(200);
    setLogs((data ?? []) as ActivityLog[]);
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      <PageHeader title="Historial" subtitle="Registro de acciones administrativas." />

      {loading ? (
        <Spinner label="Cargando historial…" />
      ) : logs.length === 0 ? (
        <Card>
          <EmptyState
            icon="ri-history-line"
            title="Aún no hay actividad registrada"
            description="Tus cambios en el panel aparecerán aquí."
          />
        </Card>
      ) : (
        <Card className="divide-y divide-background-100">
          {logs.map((log) => (
            <div key={log.id} className="flex items-start gap-3 px-5 py-4">
              <div className="w-8 h-8 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center shrink-0">
                <i className="ri-history-line" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm text-foreground-800 leading-snug">
                  <span className="font-medium">{log.usuario || "Admin"}</span> {log.accion}
                  {log.elemento && <span className="text-foreground-600"> — {log.elemento}</span>}
                </p>
                <p className="text-xs text-foreground-400 mt-0.5">{formatDateTime(log.created_at)}</p>
              </div>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}